export default "__VITE_ASSET__4zppEFNm__"